/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorRadioButton from 'base/components/labrador/RadioButton';

export const DynamicLabradorRadioButton: typeof LabradorRadioButton = (props) => {
    return <ErrorBoundary><LabradorRadioButton {...props} /></ErrorBoundary>;
}
export type DynamicLabradorRadioButtonProps = PropsFromComponent<typeof LabradorRadioButton>;
